module.exports = __webpack_public_path__ + "static/media/send-letter-info-img1@2x.90ada1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img1@2x.png
// module id = 597
// module chunks = 1